/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';

// icons

import { ReactComponent as Moto } from 'design_system/src/static/icons/motorcycle.svg';
import { ReactComponent as ID } from 'design_system/src/static/icons/user-card-2.svg';
// import { ReactComponent as Save } from "design_system/src/static/icons/save.svg";
import { ReactComponent as Ruler } from 'design_system/src/static/icons/ruler-pencil.svg';

import Divider from '@mui/material/Divider';
import { Button, Input, SideModal, Typography } from 'design_system/src';

// css
import { fetchByPostalCode } from 'models/circulocredito/controllers/zipcode.controller';
import {
	canCreateFinancialFormByCurp,
	createCreditLineFinancialForm,
	createLoanFinancialForm,
	updateCreditLineFinancialForm,
	updateFinancialForm,
} from 'models/financial-form/controllers/financial-form.controller';
import { WhitelistNameEnum } from 'models/whitelist/interfaces/whitelist.interface';
import {
	EconomicActivityEnum,
	FinancialFormTypeEnum,
	FormStatus,
} from 'models/financial-form/enums/financial-form.enums';
import {
	CreateCreditLineFinancialFormDto,
	CreateLoanFinancialFormDto,
	GenericFinancialForm,
} from 'models/financial-form/interfaces/financial-form.interfaces';
import { getCities } from 'models/inventory/controllers/vehicle.controller';
import { Sku } from 'models/sku/interfaces/sku.interface';
import { SkuVariant } from 'models/sku-variant/interfaces/sku-variant.interface';
import {
	createOzoner,
	findOzonerByCurp,
	updateOzoner,
} from 'models/ozoner/controllers/ozoner.controller';
import {
	CreateOzonerDto,
	Ozoner,
	UpdateOzonerDto,
} from 'models/ozoner/interfaces/ozoner.interface';
import { AcceptanceMethodEnum } from 'models/shared/enums/acceptanceMethod.enum';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { sanitizeName } from 'models/shared/helpers/utils';
import { getGenericMotoImageUrl } from 'models/upload/publicStorage';
import { useNavigate } from 'react-router-dom';
import SkuList from 'views/sku/SkuList';
import useProviders from 'hooks/useProviders';
import { variantLabel } from 'models/sku-variant/helpers/skuVariantLabel';
import { toasterOptions } from '../../../models/shared/enums/toaster.enum';
import '../ozoner.scss';
import {
	addressDefaults,
	addressFields,
	addressValidationSchema,
	financialDefaults,
	financialFields,
	financialValidationSchema,
	ozonerDefaults,
	ozonerFields,
	ozonerValidationSchema,
	personalDefaults,
	personalFields,
	personalValidationSchema,
	reference1Fields,
	reference2Fields,
	referencesDefaults,
	referencesValidationSchema,
} from './constants';
import { GenericFormInput } from './GenericFormInput';
import LocationModalEdit from './LocationModalEdit';

interface EditProps {
	open: boolean;
	setOpen: Function;
	setResult: Function;
	ozoner?: Ozoner | null;
	form?: GenericFinancialForm | null;
	label?: string;
	sections?: boolean[];
	hasLoan?: boolean;
}

const formatNumber = (number: string) => {
	if (!number.startsWith('521')) {
		return `521${number}`;
	}
	return number;
};
function EditOzoner({
	open,
	setOpen,
	ozoner,
	form,
	setResult,
	label = 'Crear nueva Solicitud',
	sections = [true, true, true, true],
	hasLoan = false,
}: EditProps) {
	const navigate = useNavigate();

	const [openLocation, setOpenLocation] = useState(false);
	const [ozonerData, setOzonerData] = useState<Partial<Ozoner>>(ozonerDefaults);
	const [addressI, setAddressI] =
		useState<typeof addressDefaults>(addressDefaults);
	const [referencesI, setReferencesI] =
		useState<typeof referencesDefaults>(referencesDefaults);
	const [financialI, setFinancialI] =
		useState<typeof financialDefaults>(financialDefaults);
	const [personalI, setPersonalI] =
		useState<typeof personalDefaults>(personalDefaults);

	const [formType, setFormType] = useState<'ozon' | 'creditLine'>('ozon');
	const [fullOpen, setFullOpen] = useState(false);
	const [curpValidation, setCurpValidation] = useState(false);
	const [curpActiveError, setCurpActiveError] = useState('');
	const [whitelistName, setWhitelistName] = useState<WhitelistNameEnum | null>(
		null,
	);

	const [sku, setSku] = useState<Sku>();
	const [skuVariant, setSkuVariant] = useState<SkuVariant>();

	const [loading, setLoading] = useState<boolean>(false);
	const [loadingValidation, setLoadingValidation] = useState<boolean>(false);
	const [showErrors, setShowErrors] = useState<boolean>(false);
	const [showRef1OtherField, setShowRef1OtherField] = useState(false);
	const [showRef2OtherField, setShowRef2OtherField] = useState(false);
	const [neighborhoodOptions, setNeighborhoodOptions] = useState<string[]>([]);
	const [loadingCP, setloadingCP] = useState(false);
	const providers = useProviders();

	const [location, setLocation] = useState<
		| {
				latitude: number;
				longitude: number;
		  }
		| undefined
	>();

	const [cities, setCities] = useState<any[]>([]);

	const ozonerF = useFormik({
		initialValues: ozonerData,
		validateOnMount: true,
		enableReinitialize: true,
		validationSchema: ozonerValidationSchema,
		onSubmit: () => {},
	});
	const addressF = useFormik({
		initialValues: addressI,
		validateOnMount: true,
		enableReinitialize: true,
		validationSchema: addressValidationSchema,
		onSubmit: () => {},
	});
	const referencesF = useFormik({
		initialValues: referencesI,
		validateOnMount: true,
		enableReinitialize: true,
		validationSchema: referencesValidationSchema,
		onSubmit: () => {},
	});
	const personalF = useFormik({
		initialValues: personalI,
		validateOnMount: true,
		enableReinitialize: true,
		validationSchema: personalValidationSchema,
		onSubmit: () => {},
	});
	const financialF = useFormik({
		initialValues: financialI,
		validateOnMount: true,
		enableReinitialize: true,
		validationSchema: financialValidationSchema,
		onSubmit: () => {},
	});

	useEffect(() => {
		if (ozoner) {
			const {
				firstName,
				middleName,
				lastName,
				secondLastName,
				email,
				curp,
				city,
			} = ozoner;
			setOzonerData({
				firstName,
				middleName,
				lastName,
				secondLastName,
				email,
				curp,
				city,
			});

			if (!form && curp) {
				canCreateFinancialFormByCurp(curp)
					.then(({ whitelistName: curpWhitelistName }) => {
						setWhitelistName(curpWhitelistName as WhitelistNameEnum | null);
						if (
							curpWhitelistName === WhitelistNameEnum.creditLine ||
							curpWhitelistName === WhitelistNameEnum.payJoyEmployees
						) {
							setFormType('creditLine');
						}
					})
					.catch(() => {});
			}
		}
		if (form) {
			const personalRefs =
				form.type === FinancialFormTypeEnum.creditLine
					? form.personalReferences
					: form.personalInformation?.personalReferences;

			if (form.personalInformation?.fullAddress) {
				const { lat, long } = form.personalInformation.fullAddress;
				setAddressI({
					...form.personalInformation.fullAddress,
				});
				if (lat && long) {
					setLocation({
						latitude: lat,
						longitude: long,
					});
				}
			}

			// TODO: Set The Other reference field correcttly
			setReferencesI({
				ref1name: personalRefs?.personalReference1?.name ?? '',
				ref1phone: personalRefs?.personalReference1?.phone ?? '',
				ref1relationship: personalRefs?.personalReference1?.relationship ?? '',
				ref1other: personalRefs?.personalReference1?.relationship ?? '',
				ref2name: personalRefs?.personalReference2?.name ?? '',
				ref2phone: personalRefs?.personalReference2?.phone ?? '',
				ref2relationship: personalRefs?.personalReference2?.relationship ?? '',
				ref2other: personalRefs?.personalReference2?.relationship ?? '',
			});
			// TODO:Separate Assets of other assets
			// let assets = form.financialInformation?.assets?.assets || [];
			let assets: any = [];
			if (!Array.isArray(assets)) assets = [assets];
			if (assets?.other) {
				assets = [...assets, 'otro'];
			}
			setFinancialI({
				...(form.financialInformation as any),
				economicActivity: form.financialInformation?.economicActivity?.value,
				economicActivityOther:
					form.financialInformation?.economicActivity?.description,
			});
			setPersonalI(form.personalInformation as any);
			if (
				form.personalInformation?.personalReferences?.personalReference1
					?.relationship === 'Otro'
			) {
				setShowRef1OtherField(true);
			}
			if (
				form.personalInformation?.personalReferences?.personalReference2
					?.relationship === 'Otro'
			) {
				setShowRef2OtherField(true);
			}
		}

		if (!ozoner && !form) {
			setCurpValidation(true);
		}
	}, [ozoner, form]);

	useEffect(() => {
		getCities().then((citiesR) => {
			if (citiesR) {
				setCities(citiesR.map((c) => ({ label: c.name, value: c._id })));
			}
		});
	}, []);

	const clearForm = () => {
		setCurpValidation(true);
		setFormType('ozon');
		setSku(undefined);
		setSkuVariant(undefined);
		setOpen(false);
		setOzonerData(ozonerDefaults);
		setAddressI(addressDefaults);
		setLocation(undefined);
		setReferencesI(referencesDefaults);
		setPersonalI(personalDefaults);
		setFinancialI(financialDefaults);
		ozonerF.resetForm();
		addressF.resetForm();
		referencesF.resetForm();
		personalF.resetForm();
		financialF.resetForm();
		setLoading(false);
		setCurpActiveError('');
		setWhitelistName(null);
	};

	const isValidForm = () => {
		let valid = true;
		let msg = '';

		if (formType === 'creditLine') {
			if (sections[0] && !ozonerF.isValid) {
				valid = false;
				msg = 'Información basica incompleta';
			} else if (!(addressF.isValid && !!location)) {
				valid = false;
				msg = 'Dirección incompleta';
			} else if (!personalF.values.phone) {
				valid = false;
				msg = 'El teléfono es requerido';
			}
		} else if (sections[0] && !ozonerF.isValid) {
			valid = false;
			msg = 'Información basica incompleta';
		} else if (sections[1] && !(addressF.isValid && !!location)) {
			valid = false;
			msg = 'Dirección incompleta';
		} else if (sections[2] && !referencesF.isValid) {
			valid = false;
			msg = 'Referencias personales incompletas';
		} else if (sections[3]) {
			if (!financialF.isValid) {
				valid = false;
				msg = 'Información financiera incompleta';
			} else if (!personalF.isValid) {
				valid = false;
				msg = 'Información personal incompleta';
			}
		}

		if (!valid) {
			toasterNotification({
				msg,
				style: 'light',
				toasterType: toasterOptions.error,
			});
		}

		return valid;
	};

	const onSubmit = () => {
		setLoading(true);
		if (!isValidForm()) {
			setLoading(false);
			setShowErrors(true);
			return;
		}

		let ozonerCreateDTO = {};
		let financialFormCreateDTO: any = {};
		// Ozoners creados antes de quitar "childrenCount" del modelo aún lo
		// tienen guardado en Mongo; si se reenvía tal cual, el backend lo
		// rechaza porque el DTO ya no lo declara.
		const existingPersonalInformation: any = { ...form?.personalInformation };
		delete existingPersonalInformation.childrenCount;
		if (sections[0]) {
			ozonerCreateDTO = { ...ozonerF.values };
		}
		if (sku && skuVariant) {
			financialFormCreateDTO = {
				...financialFormCreateDTO,
				sku: sku._id,
				skuVariant: skuVariant._id,
			};
		}
		if (sections[1] && location) {
			financialFormCreateDTO = {
				...financialFormCreateDTO,
				personalInformation: {
					...existingPersonalInformation,
					...financialFormCreateDTO.personalInformation,
					fullAddress: {
						...addressF.values,
						lat: location.latitude,
						long: location.longitude,
					},
				},
			};
		}
		if (sections[2]) {
			if (form?.type === FinancialFormTypeEnum.creditLine) {
				financialFormCreateDTO = {
					...financialFormCreateDTO,
					personalReferences: {
						personalReference1: {
							name: sanitizeName(referencesF.values.ref1name),
							phone: formatNumber(`${referencesF.values.ref1phone}`),
							relationship:
								referencesF.values.ref1relationship === 'Otro'
									? referencesF.values.ref1other
									: referencesF.values.ref1relationship,
						},
						personalReference2: {
							name: sanitizeName(referencesF.values.ref2name),
							phone: formatNumber(`${referencesF.values.ref2phone}`),
							relationship:
								referencesF.values.ref2relationship === 'Otro'
									? referencesF.values.ref2other
									: referencesF.values.ref2relationship,
						},
					},
				};
			} else {
				financialFormCreateDTO = {
					...financialFormCreateDTO,
					personalInformation: {
						...existingPersonalInformation,
						...financialFormCreateDTO.personalInformation,
						personalReferences: {
							personalReference1: {
								name: sanitizeName(referencesF.values.ref1name),
								phone: formatNumber(`${referencesF.values.ref1phone}`),
								relationship:
									referencesF.values.ref1relationship === 'Otro'
										? referencesF.values.ref1other
										: referencesF.values.ref1relationship,
							},
							personalReference2: {
								name: sanitizeName(referencesF.values.ref2name),
								phone: formatNumber(`${referencesF.values.ref2phone}`),
								relationship:
									referencesF.values.ref2relationship === 'Otro'
										? referencesF.values.ref2other
										: referencesF.values.ref2relationship,
							},
						},
					},
				};
			}
		}
		if (sections[3]) {
			const asset: string[] = financialF.values.assets ?? [];
			const assets = [
				...asset.filter((ele: string) => ele !== 'otro'),
				...(financialF.values.assetsOther && asset.includes('otro')
					? financialF.values.assetsOther
							.split(',')
							.map((ele: string) => ele.trim())
					: []),
			];
			const financialCopy: any = { ...financialF.values };
			financialCopy.monthlyIncome =
				financialCopy.monthlyIncome !== ''
					? parseInt(financialCopy.monthlyIncome, 10)
					: 0;
			financialCopy.monthlyOutcome =
				financialCopy.monthlyOutcome !== ''
					? parseInt(financialCopy.monthlyOutcome, 10)
					: 0;
			delete financialCopy.assetsOther;
			delete financialCopy.economicActivityOther;
			const personalInformationCopy: any = {
				...existingPersonalInformation,
				...financialFormCreateDTO.personalInformation,
				...personalF.values,
			};
			delete personalInformationCopy.childrenCount;
			financialFormCreateDTO = {
				...financialFormCreateDTO,
				personalInformation: personalInformationCopy,
				financialInformation: {
					...form?.financialInformation,
					...financialCopy,
					assets,
					economicActivity: {
						value: financialF.values.economicActivity,
						description:
							financialF.values.economicActivity === EconomicActivityEnum.otro
								? financialF.values.economicActivityOther
								: undefined,
					},
				},
			};
		}
		const p: any = [];
		const acceptanceMeta: Pick<
			CreateCreditLineFinancialFormDto,
			'privacyPolicyAcceptance' | 'termsOfServiceAcceptance' | 'status'
		> = {
			privacyPolicyAcceptance: {
				acceptedAt: new Date(),
				privacyPolicyVersion: '1.0.0',
				acceptanceMethod: AcceptanceMethodEnum.seller,
			},
			termsOfServiceAcceptance: {
				acceptedAt: new Date(),
				termsVersion: '1.0.0',
				acceptanceMethod: AcceptanceMethodEnum.seller,
			},
			status: FormStatus.pending,
		};
		if (formType === 'creditLine') {
			const creditLineBase: Omit<CreateCreditLineFinancialFormDto, 'ozoner'> = {
				...acceptanceMeta,
				phone: personalF.values.phone,
				dialCode: personalF.values.dialCode,
				sku: sku?._id,
				skuVariant: skuVariant?._id,
				fullAddress: location
					? {
							...addressF.values,
							lat: location.latitude,
							long: location.longitude,
					  }
					: undefined,
			};
			if (!ozoner?._id) {
				p.push(
					createOzoner({ ...(ozonerCreateDTO as CreateOzonerDto) }).then(
						(ozonerR) =>
							createCreditLineFinancialForm({
								...creditLineBase,
								ozoner: ozonerR._id,
							}),
					),
				);
			} else {
				p.push(
					createCreditLineFinancialForm({
						...creditLineBase,
						ozoner: ozoner._id,
					}),
				);
				if (Object.keys(ozonerCreateDTO).length) {
					p.push(updateOzoner(ozoner._id, ozonerCreateDTO as UpdateOzonerDto));
				}
			}
		} else {
			if (!ozoner?._id || !form?._id) {
				financialFormCreateDTO.privacyPolicyAcceptance =
					acceptanceMeta.privacyPolicyAcceptance;
				financialFormCreateDTO.termsOfServiceAcceptance =
					acceptanceMeta.termsOfServiceAcceptance;
				financialFormCreateDTO.status = FormStatus.pending;
			}
			if (!ozoner?._id) {
				p.push(
					createOzoner({ ...(ozonerCreateDTO as CreateOzonerDto) }).then(
						(ozonerR) =>
							createLoanFinancialForm({
								...financialFormCreateDTO,
								ozoner: ozonerR._id,
							} as CreateLoanFinancialFormDto),
					),
				);
			} else if (!form?._id) {
				p.push(
					createLoanFinancialForm({
						...financialFormCreateDTO,
						ozoner: ozoner._id,
					} as CreateLoanFinancialFormDto),
				);
				p.push(updateOzoner(ozoner._id, ozonerCreateDTO as UpdateOzonerDto));
			} else {
				if (Object.keys(ozonerCreateDTO).length) {
					p.push(updateOzoner(ozoner._id, ozonerCreateDTO as UpdateOzonerDto));
				}
				if (Object.keys(financialFormCreateDTO).length) {
					if (form.type === FinancialFormTypeEnum.creditLine) {
						p.push(
							updateCreditLineFinancialForm(form._id, financialFormCreateDTO),
						);
					} else {
						p.push(updateFinancialForm(form._id, financialFormCreateDTO));
					}
				}
			}
		}
		Promise.all(p)
			.then((data) => {
				setResult(data);
				clearForm();
				toasterNotification({
					msg: 'Se actualizó el Ozoner Correctamente',
					toasterType: toasterOptions.success,
					style: 'light',
				});
			})
			.catch((err) => {
				commonErrorHandler(err);
				setLoading(false);
			});
	};

	const handleRelation1Change = (e: any) => {
		if (e.target.value === 'Otro') setShowRef1OtherField(true);
		else setShowRef1OtherField(false);
	};

	const handleRelation2Change = (e: any) => {
		if (e.target.value === 'Otro') setShowRef2OtherField(true);
		else setShowRef2OtherField(false);
	};

	const clearPostalCode = () => {
		addressF.setFieldValue('city', '');
		addressF.setFieldValue('stateCode', '');
		addressF.setFieldValue('state', '');
		addressF.setFieldValue('delegation', '');
		addressF.setFieldValue('neighborhood', '');
		setNeighborhoodOptions([]);
		addressF.setFieldTouched('zipCode', true, true);
	};

	const updatePostalCode = async (value: string) => {
		if (value.length === 5) {
			setloadingCP(true);
			fetchByPostalCode(value)
				.then((response) => {
					setloadingCP(false);
					const { data } = response;
					const firstRecord = data[0];
					addressF.setFieldValue('city', firstRecord.ciudad);
					addressF.setFieldValue('state', firstRecord.estado);
					addressF.setFieldValue('stateCode', firstRecord.codigoEstado);
					addressF.setFieldValue('delegation', firstRecord.municipio);
					addressF.setFieldValue('neighborhood', '');
					setNeighborhoodOptions(data.map((record) => record.colonia));
					addressF.setFieldTouched('zipCode', true, true);
				})
				.catch((e) => {
					setloadingCP(false);
					clearPostalCode();
				});
		} else {
			clearPostalCode();
		}
	};

	const validateCURP = () => {
		const { curp } = ozonerF.values;
		if (!curp) return;
		setLoadingValidation(true);
		setCurpActiveError('');

		const handleCurpError = (e: any) => {
			setLoadingValidation(false);
			toasterNotification({
				msg: e ?? 'Ocurrio un error',
				toasterType: toasterOptions.error,
				style: 'light',
			});
		};

		const redirectToExistingOzoner = (
			ozonerCurp: Awaited<ReturnType<typeof findOzonerByCurp>>,
		) => {
			setLoadingValidation(false);
			if (!ozonerCurp) return false;
			navigate(`/ozoner/${ozonerCurp._id}?openEdit=true`);
			return true;
		};

		canCreateFinancialFormByCurp(curp)
			.then(({ canCreateByCurp, whitelistName: curpWhitelistName }) => {
				if (!canCreateByCurp) {
					setLoadingValidation(false);
					setCurpActiveError(
						'Este CURP ya tiene una solicitud activa, no se puede crear una nueva',
					);
					return;
				}
				findOzonerByCurp(curp)
					.then((ozonerCurp) => {
						if (redirectToExistingOzoner(ozonerCurp)) return;
						setCurpValidation(false);
						setWhitelistName(curpWhitelistName as WhitelistNameEnum | null);
						if (
							curpWhitelistName === WhitelistNameEnum.creditLine ||
							curpWhitelistName === WhitelistNameEnum.payJoyEmployees
						) {
							setFormType('creditLine');
						}
					})
					.catch(handleCurpError);
			})
			.catch(handleCurpError);
	};

	return (
		<>
			<SideModal
				open={open}
				setOpen={setOpen}
				fullOpen={fullOpen}
				setFullOpen={setFullOpen}
				size="normal"
			>
				<div className="flex_content_col">
					<div className="flex_header">
						<Typography
							scale="heading4"
							weight="600"
							textColor="neutral_900"
							className="m_b_lg m_t_md"
						>
							{label}
						</Typography>
						<Divider />
					</div>
					{curpValidation ? (
						<>
							<form>
								<Input
									onBlur={ozonerF.handleBlur}
									error={
										!!curpActiveError ||
										(!!ozonerF.errors['curp'] &&
											(ozonerF.getFieldMeta('curp').touched || showErrors))
									}
									subtitle={
										// eslint-disable-next-line no-nested-ternary
										hasLoan
											? 'No se puede editar el CURP de un ozoner con crédito'
											: // eslint-disable-next-line no-nested-ternary
											  curpActiveError ||
											  (ozonerF.getFieldMeta('curp').touched || showErrors
													? (ozonerF.errors['curp'] as string)
													: undefined)
									}
									title="CURP*"
									placeholder="Escribe el CURP aquí"
									name="curp"
									type="text"
									icon={<ID />}
									className="m_y_xs w_100_per"
									value={ozonerF.values.curp}
									onChange={(e) => {
										setCurpActiveError('');
										ozonerF.handleChange(e);
									}}
									disabled={hasLoan}
								/>
							</form>
							<Button
								scale="small"
								orientation="right"
								className="w_100_per"
								onClick={() => {
									validateCURP();
								}}
								disabled={
									loadingValidation ||
									ozonerF.values['curp'] === '' ||
									!!ozonerF.errors['curp']
								}
							>
								Verificar Curp
							</Button>
						</>
					) : (
						<>
							{!form?._id && (
								<Input
									title="Tipo de crédito"
									name="formType"
									type="select"
									options={[
										{ label: 'Crédito Ozon', value: 'ozon' },
										{ label: 'Crédito Credit Line', value: 'creditLine' },
									]}
									value={formType}
									onChange={(e: any) => setFormType(e.target.value)}
									disabled={
										whitelistName === WhitelistNameEnum.creditLine ||
										whitelistName === WhitelistNameEnum.payJoyEmployees
									}
									className="m_b_xs w_100_per"
								/>
							)}
							{!form?._id &&
							(whitelistName === WhitelistNameEnum.creditLine ||
								whitelistName === WhitelistNameEnum.payJoyEmployees) ? (
								<div className="border_solid border_1 border_green_300 p_md m_b_md">
									<Typography
										scale="small"
										weight="600"
										textColor="neutral_700"
									>
										Este usuario pertenece a la whitelist:{' '}
										<Typography
											scale="small"
											weight="600"
											component="span"
											textColor="green_300"
										>
											{whitelistName}
										</Typography>
									</Typography>
								</div>
							) : null}
							<div className="flex_body p_y_lg p_x_sm overflow_x_hidden">
								<form>
									{sections[0] ? (
										<>
											<Typography
												scale="heading4"
												weight="600"
												textColor="neutral_700"
												className="m_b_xl"
											>
												Información basica
											</Typography>
											<Grid
												container
												direction="row"
												rowSpacing={0}
												columnSpacing={6}
												justifyContent="center"
												className=""
											>
												{Object.entries(ozonerFields).map(([key, value]) => (
													<Grid item xs={value.size} key={key}>
														<GenericFormInput
															params={{
																...value,
																form: ozonerF,
																forceDisplayError: showErrors,
																options:
																	key === 'city' ? cities : value.options,
																disabled:
																	key === 'curp' && (hasLoan || !form?._id),
																subtitle:
																	// eslint-disable-next-line no-nested-ternary
																	key === 'curp' && (hasLoan || !form?._id)
																		? hasLoan
																			? 'No se puede editar el CURP de un ozoner con crédito'
																			: 'El CURP ya fue verificado, no se puede modificar'
																		: undefined,
															}}
														/>
													</Grid>
												))}
											</Grid>
										</>
									) : null}
									{formType === 'creditLine' ? (
										<>
											{!form?._id ? (
												<div className="flex_center m_b_md">
													<div className="dso_card bg_neutral_0 flex_center_col p_md">
														<Typography
															scale="xsmall"
															weight="600"
															textColor="neutral_900"
															className="text_center m_b_md"
														>
															{!sku ? 'ASIGNAR SKU' : sku.code}
														</Typography>
														<div
															className="dso_card_img m_b_md bg_neutral_200 w_fit display_flex overflow_hidden border_primary_100"
															onClick={() => {
																setFullOpen(true);
															}}
															onKeyPress={() => {
																setFullOpen(true);
															}}
															role="button"
															tabIndex={0}
														>
															{sku ? (
																<img
																	src={
																		sku.images?.[0]?.url ??
																		getGenericMotoImageUrl()
																	}
																	alt=""
																	className="cards_photo"
																/>
															) : (
																<Moto className="dim_xl m_lg border_transparent" />
															)}
														</div>
														{skuVariant ? (
															<Typography
																scale="xsmall"
																weight="400"
																textColor="neutral_600"
																className="text_center m_t_xs"
															>
																{variantLabel(skuVariant, providers)}
															</Typography>
														) : null}
													</div>
												</div>
											) : null}
											{sections[0] ? <Divider variant="middle" /> : null}
											<Typography
												scale="heading4"
												weight="600"
												textColor="neutral_700"
												className="m_y_xl"
											>
												Dirección
											</Typography>
											<Grid
												container
												direction="row"
												rowSpacing={0}
												columnSpacing={6}
												justifyContent="center"
												className=""
											>
												<Grid item xs={6}>
													<GenericFormInput
														params={{
															...addressFields.zipCode,
															form: addressF,
															forceDisplayError: showErrors,
															onChange: (e) => {
																updatePostalCode(e.target.value);
															},
														}}
													/>
													{loadingCP ? (
														<Typography
															scale="large"
															weight="600"
															textColor="neutral_700"
															className="m_y_sm text_center"
														>
															Cargando...
														</Typography>
													) : null}
												</Grid>
												{Object.entries(addressFields)
													.filter(
														([key]) => !['zipCode', 'stateCode'].includes(key),
													)
													.map(([key, value]) => (
														<Grid item xs={value.size} key={key}>
															<GenericFormInput
																params={{
																	...value,
																	form: addressF,
																	forceDisplayError: showErrors,
																	options:
																		key === 'neighborhood'
																			? neighborhoodOptions
																			: value.options,
																}}
															/>
														</Grid>
													))}
											</Grid>
											<Button
												variant="outline"
												scale="small"
												onClick={() => setOpenLocation(true)}
												className="w_100_per"
											>
												Asignar ubicación exacta
											</Button>
											{location ? (
												<div className="bg_neutral_400 p_x_md p_y_xs flex_center m_t_md">
													<Typography
														scale="small"
														weight="600"
														textColor="neutral_700"
														className=""
													>
														{location.latitude},{location.longitude}
													</Typography>
												</div>
											) : (
												<Typography
													scale="medium"
													weight="600"
													textColor="red_300"
													className=" text_center m_t_md"
												>
													No se ha asignado ubicacion exacta
												</Typography>
											)}
											<Divider variant="middle" />
											<Typography
												scale="heading4"
												weight="600"
												textColor="neutral_700"
												className="m_y_xl"
											>
												Personal
											</Typography>
											<Grid
												container
												direction="row"
												rowSpacing={0}
												columnSpacing={6}
												justifyContent="center"
												className=""
											>
												<Grid item xs={personalFields.dialCode.size}>
													<GenericFormInput
														params={{
															...personalFields.dialCode,
															form: personalF,
															forceDisplayError: showErrors,
														}}
													/>
												</Grid>
												<Grid item xs={personalFields.phone.size}>
													<GenericFormInput
														params={{
															...personalFields.phone,
															form: personalF,
															forceDisplayError: showErrors,
														}}
													/>
												</Grid>
											</Grid>
										</>
									) : (
										<>
											{!form?._id && sections[3] ? (
												<div className="flex_center m_b_md">
													<div className="dso_card bg_neutral_0 flex_center_col p_md">
														<Typography
															scale="xsmall"
															weight="600"
															textColor="neutral_900"
															className="text_center m_b_md"
														>
															{!sku ? 'ASIGNAR SKU' : sku.code}
														</Typography>
														<div
															className="dso_card_img m_b_md bg_neutral_200 w_fit display_flex overflow_hidden border_primary_100"
															onClick={() => {
																setFullOpen(true);
															}}
															onKeyPress={() => {
																setFullOpen(true);
															}}
															role="button"
															tabIndex={0}
														>
															{sku ? (
																<img
																	src={
																		sku.images?.[0]?.url ??
																		getGenericMotoImageUrl()
																	}
																	alt=""
																	className="cards_photo"
																/>
															) : (
																<Moto className="dim_xl m_lg border_transparent" />
															)}
														</div>
														{skuVariant ? (
															<Typography
																scale="xsmall"
																weight="400"
																textColor="neutral_600"
																className="text_center m_t_xs"
															>
																{variantLabel(skuVariant, providers)}
															</Typography>
														) : null}
													</div>
												</div>
											) : null}
											<>
												{sections[1] ? (
													<>
														{sections[0] ? <Divider variant="middle" /> : null}
														<Typography
															scale="heading4"
															weight="600"
															textColor="neutral_700"
															className="m_y_xl"
														>
															Dirección
														</Typography>
														<Grid
															container
															direction="row"
															rowSpacing={0}
															columnSpacing={6}
															justifyContent="center"
															className=""
														>
															<Grid item xs={6}>
																<GenericFormInput
																	params={{
																		...addressFields.zipCode,
																		form: addressF,
																		forceDisplayError: showErrors,
																		onChange: (e) => {
																			updatePostalCode(e.target.value);
																		},
																	}}
																/>
																{loadingCP ? (
																	<Typography
																		scale="large"
																		weight="600"
																		textColor="neutral_700"
																		className="m_y_sm text_center"
																	>
																		Cargando...
																	</Typography>
																) : null}
															</Grid>
															{Object.entries(addressFields)
																.filter(
																	([key]) =>
																		!['zipCode', 'stateCode'].includes(key),
																)
																.map(([key, value]) => (
																	<Grid item xs={value.size} key={key}>
																		<GenericFormInput
																			params={{
																				...value,
																				form: addressF,
																				forceDisplayError: showErrors,
																				options:
																					key === 'neighborhood'
																						? neighborhoodOptions
																						: value.options,
																			}}
																		/>
																	</Grid>
																))}
														</Grid>
														<Button
															variant="outline"
															scale="small"
															onClick={() => setOpenLocation(true)}
															className="w_100_per"
														>
															Asignar ubicación exacta
														</Button>
														{location ? (
															<div className="bg_neutral_400 p_x_md p_y_xs flex_center m_t_md">
																<Typography
																	scale="small"
																	weight="600"
																	textColor="neutral_700"
																	className=""
																>
																	{location.latitude},{location.longitude}
																</Typography>
															</div>
														) : (
															<Typography
																scale="medium"
																weight="600"
																textColor="red_300"
																className=" text_center m_t_md"
															>
																No se ha asignado ubicacion exacta
															</Typography>
														)}
													</>
												) : null}

												{sections[2] ? (
													<>
														{sections[0] || sections[1] ? (
															<Divider variant="middle" />
														) : null}

														<Typography
															scale="heading4"
															weight="600"
															textColor="neutral_700"
															className="m_y_xl"
														>
															Referencias personales
														</Typography>
														<Grid
															container
															direction="row"
															rowSpacing={0}
															columnSpacing={6}
															justifyContent="center"
															className=""
														>
															<Grid item xs={6}>
																{Object.entries(reference1Fields)
																	.filter(
																		([key]) =>
																			key !== 'ref1other' || showRef1OtherField,
																	)
																	.map(([key, value]) => (
																		<GenericFormInput
																			params={{
																				...value,
																				form: referencesF,
																				forceDisplayError: showErrors,
																				onChange:
																					key === 'ref1relationship'
																						? handleRelation1Change
																						: undefined,
																			}}
																		/>
																	))}
															</Grid>
															<Grid item xs={6}>
																{Object.entries(reference2Fields)
																	.filter(
																		([key]) =>
																			key !== 'ref2other' || showRef2OtherField,
																	)
																	.map(([key, value]) => (
																		<GenericFormInput
																			params={{
																				...value,
																				form: referencesF,
																				forceDisplayError: showErrors,
																				onChange:
																					key === 'ref2relationship'
																						? handleRelation2Change
																						: undefined,
																			}}
																		/>
																	))}
															</Grid>
														</Grid>
													</>
												) : null}
												{sections[3] ? (
													<>
														{sections[0] || sections[1] || sections[2] ? (
															<Divider variant="middle" />
														) : null}
														<Typography
															scale="heading4"
															weight="600"
															textColor="neutral_700"
															className="m_y_xxl"
														>
															Personal
														</Typography>

														<Grid
															container
															direction="row"
															rowSpacing={0}
															columnSpacing={6}
															justifyContent="center"
															className=""
														>
															{Object.entries(personalFields).map(
																([key, value]) => (
																	<Grid item xs={value.size}>
																		<GenericFormInput
																			params={{
																				...value,
																				form: personalF,
																				forceDisplayError: showErrors,
																			}}
																		/>
																	</Grid>
																),
															)}
														</Grid>

														<Divider variant="middle" />

														<Typography
															scale="heading4"
															weight="600"
															textColor="neutral_700"
															className="m_y_xxl"
														>
															Financiero
														</Typography>

														<Grid
															container
															direction="row"
															rowSpacing={0}
															columnSpacing={6}
															justifyContent="center"
															className=""
														>
															<Grid item xs={12}>
																<GenericFormInput
																	params={{
																		...financialFields.monthlyIncome,
																		form: financialF,
																		forceDisplayError: showErrors,
																	}}
																/>
															</Grid>
															<Grid item xs={12}>
																<GenericFormInput
																	params={{
																		...financialFields.monthlyOutcome,
																		form: financialF,
																		forceDisplayError: showErrors,
																	}}
																/>
															</Grid>
															<Grid item xs={12}>
																<GenericFormInput
																	params={{
																		...financialFields.companyName,
																		form: financialF,
																		forceDisplayError: showErrors,
																	}}
																/>
															</Grid>
														</Grid>
														<Grid
															container
															direction="row"
															rowSpacing={0}
															columnSpacing={6}
															justifyContent="center"
															className=""
														>
															<Grid item sm={6}>
																<GenericFormInput
																	params={{
																		...financialFields.economicActivity,
																		form: financialF,
																		forceDisplayError: showErrors,
																	}}
																/>
																{financialF.values.economicActivity ===
																EconomicActivityEnum.otro ? (
																	<GenericFormInput
																		params={{
																			...financialFields.economicActivityOther,
																			form: financialF,
																			forceDisplayError: showErrors,
																		}}
																	/>
																) : null}
															</Grid>
															<Grid item xs={6}>
																<GenericFormInput
																	params={{
																		...financialFields.assets,
																		form: financialF,
																		forceDisplayError: showErrors,
																	}}
																/>
																{(
																	financialF.values.assets as string[]
																).includes('otro') ? (
																	<GenericFormInput
																		params={{
																			...financialFields.assetsOther,
																			form: financialF,
																			forceDisplayError: showErrors,
																		}}
																	/>
																) : null}
															</Grid>
														</Grid>
														<div className="display_flex flex_align_center flex_gap_xxl m_y_xl">
															<div>
																<div className="display_flex flex_gap_xs flex_align_center m_b_xs">
																	<Ruler className="dim_lg text_primary_300" />
																	<Typography
																		scale="medium"
																		weight="600"
																		textColor="neutral_900"
																	>
																		¿El ozoner trabaja en plataformas digitales?
																	</Typography>
																</div>
																<Typography
																	scale="xsmall"
																	weight="400"
																	textColor="neutral_900"
																>
																	Se enviara un correo al ozoner para la
																	validacion de su cuenta
																</Typography>
															</div>
															<div className="flex_center p_x_sm bg_neutral_300 br_xs">
																<Input
																	title=""
																	name="workInDigitalPlatforms"
																	type="slider"
																	value={
																		financialF.values.workInDigitalPlatforms
																	}
																	onChange={financialF.handleChange}
																/>
															</div>
														</div>
													</>
												) : null}
											</>
										</>
									)}
								</form>
							</div>

							<div className="flex_footer">
								<Button
									scale="large"
									orientation="right"
									className="w_100_per"
									type="submit"
									onClick={() => {
										setShowErrors(true);
										onSubmit();
									}}
									disabled={
										loading ||
										(!ozonerF.dirty &&
											!addressF.dirty &&
											!referencesF.dirty &&
											!personalF.dirty &&
											!financialF.dirty &&
											!sku)
										// TODO: Fix this
										// &&
										// (!ozoner?.fullAddress || !location || ozoner.fullAddress.lat === location?.latitude )&&
										// (!ozoner?.fullAddress || !location || ozoner.fullAddress.long === location?.longitude )
									}
								>
									Guardar
								</Button>
							</div>
						</>
					)}
				</div>
				{fullOpen && (
					<SkuList
						onClick={(selectedSku, selectedVariant) => {
							setSku(selectedSku);
							setSkuVariant(selectedVariant);
							setFullOpen(false);
						}}
						selectedSkuId={sku?._id}
						selectedVariantId={skuVariant?._id}
					/>
				)}
			</SideModal>
			{openLocation && (
				<LocationModalEdit
					openModal={openLocation}
					setOpenModal={setOpenLocation}
					addressData={addressF.values}
					saveLocation={setLocation}
					initialLocation={location}
				/>
			)}
		</>
	);
}

export default EditOzoner;
